<template>
  <h3 class="font-16 margin-bottom-10 margin-top-15 font-weight color-333">
    <span v-html="title"></span>
  </h3>
</template>
<script >
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String,
    default: ''
  },
  path: {
    type: String,
    default: ''
  }
};
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
